import { render, staticRenderFns } from "./ProjectTransfer.vue?vue&type=template&id=9bf46668"
import script from "./ProjectTransfer.vue?vue&type=script&lang=js"
export * from "./ProjectTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports